import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { lazyRetry } from '@utils/lazyRetry';
import { layoutConfigOnlyMain } from '@/configs/layoutConfigTemplates';

const OrchestrationApp = lazyRetry(() => import('./OrchestrationApp'));

// Orchestration workspace route — full-viewport canvas with no Fuse chrome.
// Auto-registered by routesConfig.tsx via the Vite glob that matches *Route.tsx files under /src/app.
const OrchestrationRoute: FuseRouteItemType = {
  path: 'orchestration',
  element: <OrchestrationApp />,
  settings: { layout: layoutConfigOnlyMain },
};

export default OrchestrationRoute;
